export default {"src":"/_next/static/media/ecommerceLogo4.8f64a487.svg","height":36,"width":188,"blurWidth":0,"blurHeight":0};